import React from "react";

const TYPE_CLASSES = {
  primary: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200",
  success: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200",
  warning: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-200",
  danger: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200",
  neutral: "bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200",
};

function Badge({ type = "neutral", className = "", children, ...props }) {
  const tone = TYPE_CLASSES[type] || TYPE_CLASSES.neutral;
  const classes = [
    "inline-flex items-center rounded-full px-3 py-1 text-sm font-medium leading-none whitespace-nowrap",
    tone,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
}

export default Badge;
